import { render, staticRenderFns } from "./GenderIcon.vue?vue&type=template&id=4c03bee4"
import script from "./GenderIcon.vue?vue&type=script&lang=ts"
export * from "./GenderIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports